import { GetApp } from "../../App"
import { Ship } from "../../App/Ship"
import { GetShip } from "../../App/Context"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { EditGroup } from "../../Components/EditGroup"
import { Select } from "../../Components/Select"
import { GetNMEAConfigurationContext } from "./Context"

export function NMEAConfigurationConditionsView() {
  const app = GetApp()!;
  const t = app.getT("NMEAConfigurationView");
  const ship = GetShip();
  const {
    edited, error, updateThresholds, interval, intervalOptions, selectIntervalOptions,
    courseChecked, setCourseChecked, onEdited, thresholds,
    engineIdleChecked, setEngineIdleChecked,
    startStopAnchorChecked, setStartStopAnchorChecked,
  } = GetNMEAConfigurationContext();

  const namePrefix = "thresholds";

  const editableFields = [{ name: "thresholds", type: "object", fields: [{ name: "interval", type: "int" }, { name: "stop", type: "float" }, { name: "resume", type: "float" }, { name: "startStopAnchor", type: "bool" }, { name: "anchorResume", type: "float" }, { name: "courseChange", type: "int" }, { name: "courseSpeed", type: "float" }, { name: "engineStart", type: "int" }, { name: "engineStop", type: "int" }, { name: "engineIdleRpm", type: "int" }, { name: "anchorDrift", type: "object", fields: [{ name: "warning", type: "float" }, { name: "alarm", type: "float" }] }, { name: "depth", type: "object", fields: [{ name: "warning", type: "float" }, { name: "alarm", type: "float" }] }] }];
  return (
    <Block key="conditions">
      <EditGroup changed={edited} editable={true} editableFields={editableFields} error={error && t("error_" + error)} onSave={updateThresholds}>
        <BlockRow className="block-row-title bold">
          {t("condition_entry")}
        </BlockRow>
        <BlockRow className="block-row-no_labels">
          <BlockField label={t("condition_interval")} className="block_field_small_12 label-left-0">
            <Select button={t("condition_interval_" + interval)} name={`${namePrefix}.interval`} onSelect={selectIntervalOptions} options={intervalOptions} value={interval} className="select_small_150" />
          </BlockField>
        </BlockRow>

        {/* start/stop entry: */}
        {/* <BlockRow className="block-row-title bold block-row-top40">
          {t("condition_start_stop")}
        </BlockRow> */}
        <BlockRow className="block-row-no_labels">
          <BlockField label={t("condition_start")} className="label-left-0">
            <span className="bold18">{"> "}</span>
            <input name={`${namePrefix}.resume`} defaultValue={app.format("speed", thresholds?.resume)} className="block_field_small_6 center" onChange={onEdited} />
          </BlockField>
          <BlockField label={t("condition_stop")} className="label-left-0">
            <span className="bold18">{"< "}</span>
            <input name={`${namePrefix}.stop`} defaultValue={app.format("speed", thresholds?.stop)} className="block_field_small_6 center" onChange={onEdited} />
          </BlockField>
        </BlockRow>

        <BlockRow className="block-row-checkboxes block-row-top20">
          <BlockField label={t("condition_anchor_start_stop")} labelAfter={true} labelFor={`startStopAnchor`}>
            <input id="startStopAnchor" type="checkbox" name={`${namePrefix}.startStopAnchor`} defaultValue={""}
              onChange={() => { setStartStopAnchorChecked(!startStopAnchorChecked); onEdited(); }} checked={startStopAnchorChecked}
            />
          </BlockField>
        </BlockRow>

        <BlockRow className="block-row-gap block-row-tight">
          <BlockField label={t("condition_anchor_no_status_change")} className="label-left-0">
            <span className="bold18">{"< "} </span>
            <input name={`${namePrefix}.anchorResume`}
              defaultValue={app.format("speed", thresholds?.anchorResume)}
              className="block_field_small_6 center" onChange={onEdited}
              readOnly={!startStopAnchorChecked}
            />
          </BlockField>
        </BlockRow>

        {/* Course change entry: */}
        <BlockRow className="block-row-checkboxes block-row-top20">
          <BlockField label={t("condition_course")} labelAfter={true} labelFor={`courseChangeEnabled`}>
            <input id="courseChangeEnabled" type="checkbox" name={`${namePrefix}.courseChangeEnabled`} defaultValue={""} onChange={() => { setCourseChecked(!courseChecked); onEdited(); }} checked={courseChecked} />
          </BlockField>
        </BlockRow>
        <BlockRow className="block-row-tight">
          <BlockField label={t("condition_course_change")} className="label-left-0 block_field_small_12">
            <span className="bold18">{"> "} </span>
            <input name={`${namePrefix}.courseChange`}
              defaultValue={app.format("angle", thresholds?.courseChange)}
              className="block_field_small_6 center"
              onChange={onEdited}
              readOnly={!courseChecked}
            />
          </BlockField>

          <BlockField label={t("blank")} className="block_field_small_4 ">
            <span className="bold">{t("and")} </span>
          </BlockField>

          <BlockField label={t("condition_course_speed")} className="label-left-0 block_field_small_12">
            <span className="bold18">{"> "} </span>
            <input name={`${namePrefix}.courseSpeed`}
              defaultValue={app.format("speed", thresholds?.courseSpeed)}
              className="block_field_small_6 center"
              onChange={onEdited}
              readOnly={!courseChecked}
            />
          </BlockField>
        </BlockRow>

        {/* engine RPM detection + idle (sailing vessels) */}
        {Ship.isSailingVessel(ship) && (
          <>
            <hr></hr>
            <BlockRow className="block-row-title bold block-row-top20">
              {t("condition_engine_detection")}
            </BlockRow>
            <BlockRow className="block-row-no_labels">
              <BlockField label={t("condition_engine_start")} className="label-left-0">
                <span className="bold18">{"> "}</span>
                <input name={`${namePrefix}.engineStart`} defaultValue={app.format("rpm", thresholds?.engineStart)} className="block_field_small_6 center" onChange={onEdited} />
              </BlockField>
              <BlockField label={t("condition_engine_stop")} className="label-left-0">
                <span className="bold18">{"< "}</span>
                <input name={`${namePrefix}.engineStop`} defaultValue={app.format("rpm", thresholds?.engineStop)} className="block_field_small_6 center" onChange={onEdited} />
              </BlockField>
            </BlockRow>
            <BlockRow className="block-row-checkboxes block-row-top20">
              <BlockField label={t("condition_engine_idle_rpm")} labelAfter={true} labelFor={`engineIdleRpmEnabled`} className="label-wrap ">
                <input id="engineIdleRpmEnabled" type="checkbox" name={`${namePrefix}.engineIdleRpmEnabled`} defaultValue={""} style={{ width: "90%" }}
                  onChange={() => { setEngineIdleChecked(!engineIdleChecked); onEdited(); }} checked={engineIdleChecked}
                />
              </BlockField>
            </BlockRow>
            <BlockRow className="block-row-tight ">
              <BlockField label={t("condition_engine_idle_rpm_value")} className="label-left-0">
                <input
                  name={`${namePrefix}.engineIdleRpm`}
                  defaultValue={app.format("rpm", thresholds?.engineIdleRpm)}
                  className="block_field_small_8 center"
                  onChange={onEdited}
                  readOnly={!engineIdleChecked}
                />
              </BlockField>
            </BlockRow>
          </>
        )}

      </EditGroup>
    </Block>
  );
}
